import SessionStorageSynchronizer from '~/utils/sync-sessionstorage';

export const useHconAuthInfo = () => {
    const hconAuthInfoHandler = {
        getIfPossible: (): AuthInfo | null | undefined => {
            if (import.meta.client) {
                const authInfoJson  = SessionStorageSynchronizer.getItem('common.auth.info');
                if (authInfoJson) {
                    return JSON.parse(authInfoJson);
                } else {
                    return null;
                }
            }

        },
        on: (callback: (authInfo?: AuthInfo | null) => void) => {
            if (import.meta.client) {
                const rv = hconAuthInfoHandler.getIfPossible();
                callback(rv ? rv : null);
            }
        },
        onExist: (callback: (authInfo: AuthInfo) => void) => {
            hconAuthInfoHandler.on(authInfo => {
                if (authInfo) {
                    callback(authInfo);
                }
            });
        },
        set: (authInfo?: AuthInfo) => {
            if (import.meta.client) {
                // const serverType        = localStorage.getItem('common.context.serverType');
                // const ulidCookieName    = serverType == 'prd' ? 'ulid4legacy' : serverType == 'local' ? 'ulid4legacy-dev' : `ulid4legacy-${serverType ?? 'dev'}`;
                if (authInfo) {
                    authInfo.lastAccess = new Date().getTime();
                    SessionStorageSynchronizer.setItem('common.auth.info', JSON.stringify(authInfo));
                    // document.cookie = `userOf=${authInfo.userContext.userOf};path=/;samesite=lax;max-age=${authInfo.accessTimeout/1000};secure`;
                    // if (authInfo.ulid4legacy) {
                    //     document.cookie = `${ulidCookieName}=${authInfo.ulid4legacy};domain=hcon.co.kr;path=/;samesite=lax;max-age=${authInfo.accessTimeout/1000};secure`;
                    //     document.cookie = `${ulidCookieName}=${authInfo.ulid4legacy};domain=hcon.co.kr;path=/;samesite=lax;max-age=${authInfo.accessTimeout/1000};secure`;
                    // }
                    return true;
                } else {
                    SessionStorageSynchronizer.removeItem('common.auth.info');
                    SessionStorageSynchronizer.removeItem('common.auth.rememberMe');
                    // document.cookie = `userOf=;path=/;samesite=lax;max-age=-1;secure`;
                    // document.cookie = `${ulidCookieName}=;domain=hcon.co.kr;path=/;samesite=lax;max-age=-1;secure`;
                    // document.cookie = `${ulidCookieName}=;domain=hcon.co.kr;path=/;samesite=lax;max-age=-1;secure`;
                }
            }
            return false;
        },
        setFromFetch: (res: any) => {
            if (res.status == 200 && res._data.resultCode == 200) {
                const resBody = res._data;
                const authInfo:AuthInfo = {
                    accessToken: res.headers.get("access_token"),
                    refreshToken: res.headers.get("refresh_token"),
                    ulid4legacy: res.headers.get('x-ulid4legacy'),
                    accessTimeout: resBody.authTimeout * 60 * 1000,
                    lastAccess: new Date().getTime(),
                    userContext: resBody.data.ezwelUserContext,
                    //addUserInfo: resBody.data.addUsrInfo
                };
                
                hconAuthInfoHandler.set(authInfo);
                return authInfo;
            }
            return null;
        },
        clear: () => {
            hconAuthInfoHandler.set();
        },
    }
    return hconAuthInfoHandler;
};











